import React from "react";

import { styled, Typography } from '@material-ui/core';

const Root = styled('div')({
 display: 'flex',
 flexDirection: 'column',
});

interface Props {
  label: string;
  value: any;
}

const ValueWithLabel: React.FC<Props> = ({label, value}) => {
  return (
    <Root>
      <Typography variant="caption">{label}</Typography>
      <Typography>{value}</Typography>
    </Root>
  );
};

export default ValueWithLabel;


// interface ValueProps {
//   label: string;
//   value: any;
// }

// const ValueContainer = styled('div')({
//   display: 'flex',
//   flexDirection: 'column',
//   // marginBottom: '15px',
// });



// const ValueWithLabel: React.FC<ValueProps> = ({ label, value }) => {
//   return (
//     <ValueContainer>
//       <Typography variant="caption">{label}</Typography>
//       <Typography>{value}</Typography>
//     </ValueContainer>
//   )
// }